import styled from "styled-components";
import React from "react";
import { toArabicNumerals } from "../../../helpers";

const Countdown = styled.div`
    margin: 30px 0;
    font-size: 40px;
    font-weight: 500;
`;

type Props = {
    seconds: number;
    onFinish: () => void;
};
type State = {
    seconds: number;
};

export default class Timer extends React.Component<Props, State> {
    private intervalId?: ReturnType<typeof setInterval>;

    state = {
        seconds: this.props.seconds,
    };

    clearInterval() {
        const i = this.intervalId;
        if (typeof i !== "undefined") {
            clearInterval((i as unknown) as number);
        }
    }

    componentDidMount() {
        this.clearInterval();
        this.intervalId = setInterval(this.onTick, 1000);
    }

    componentWillUnmount() {
        this.clearInterval();
    }

    onTick = () => {
        let { seconds } = this.state;
        seconds -= 1;

        if (seconds === 0) {
            this.clearInterval();
            this.props.onFinish();
            return;
        }

        this.setState({
            seconds,
        });
    };

    render() {
        return (
            <Countdown>
                {toArabicNumerals(this.state.seconds.toString())}
            </Countdown>
        );
    }
}
